// extracted by mini-css-extract-plugin
export default {"arrow-icon":"up-down-icon_arrow-icon__IQvPj","disabled":"up-down-icon_disabled__yi0Go"};